import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardControlKeyIcon from '@mui/icons-material/KeyboardControlKey';
import React, { useEffect, useState } from 'react';
import ComponentSubHeader from '../../../Headers/ComponentSubHeader';
import LoadingSpinner from '../../../LoadingSpinner/LoadingSpinner';
import styles from './Accordions.module.scss';

interface IPageAccordionProps {
    title: string;
    disabled?: boolean;
    component: JSX.Element | null;
    open?: boolean;
    loading?: boolean;
}

const PageAccordion = (props: IPageAccordionProps) => {
    const [accordionOpen, setAccordionOpen] = useState<boolean>();

    useEffect(() => {
        if (!props.open) {
            return;
        }

        setAccordionOpen(props.open ?? false);
    }, [props.open]);

    return (
        <div className={props.disabled ? styles.page_accordion_disabled : styles.page_accordion}>
            <ComponentSubHeader
                title={props.title}
                rightSideComponent={
                    accordionOpen ? (
                        <KeyboardControlKeyIcon className={styles.page_accordion_button} onClick={() => setAccordionOpen(false)} fontSize="large" />
                    ) : (
                        <KeyboardArrowDownIcon
                            className={styles.page_accordion_button}
                            onClick={() => {
                                if (props.disabled) {
                                    return;
                                }

                                setAccordionOpen(true);
                            }}
                            fontSize="large"
                        />
                    )
                }
                containerClassName={styles.page_accordion_header}
            />
            <div className={styles.page_accordion_conditional_component}>
                {props.loading ? (
                    <div className={styles.page_accordion_loader}>
                        <LoadingSpinner />
                    </div>
                ) : (
                    accordionOpen && props.component
                )}
            </div>
        </div>
    );
};

export default PageAccordion;
